import api from './api';

const dynamicPricingService = {
  // Buscar preços base de um custo
  getBasePrices: async (costId) => {
    try {
      const response = await api.get(`/dynamic-pricing/cost/${costId}/base-prices`);
      return response.data;
    } catch (error) {
      console.error('Erro ao buscar preços base:', error);
      throw error;
    }
  },

  // Criar preço base
  createBasePrice: async (costId, basePriceData) => {
    try {
      const response = await api.post(`/dynamic-pricing/cost/${costId}/base-prices`, basePriceData);
      return response.data;
    } catch (error) {
      console.error('Erro ao criar preço base:', error);
      throw error;
    }
  },

  // Atualizar preço base
  updateBasePrice: async (priceId, basePriceData) => {
    try {
      const response = await api.put(`/dynamic-pricing/base-prices/${priceId}`, basePriceData);
      return response.data;
    } catch (error) {
      console.error('Erro ao atualizar preço base:', error);
      throw error;
    }
  },

  // Deletar preço base
  deleteBasePrice: async (priceId) => {
    try {
      const response = await api.delete(`/dynamic-pricing/base-prices/${priceId}`);
      return response.data;
    } catch (error) {
      console.error('Erro ao deletar preço base:', error);
      throw error;
    }
  },

  // Calcular preço dinâmico
  calculateDynamicPrice: async (costId, calculationData) => {
    try {
      const response = await api.post(`/dynamic-pricing/calculate/${costId}`, calculationData);
      return response.data;
    } catch (error) {
      console.error('Erro ao calcular preço dinâmico:', error);
      throw error;
    }
  },

  // Buscar multiplicadores por categoria
  getCategoryMultipliers: async () => {
    try {
      const response = await api.get('/dynamic-pricing/category-multipliers');
      return response.data;
    } catch (error) {
      console.error('Erro ao buscar multiplicadores:', error);
      throw error;
    }
  },

  // Atualizar multiplicadores por categoria
  updateCategoryMultipliers: async (multiplierId, multiplierData) => {
    try {
      const response = await api.put(`/dynamic-pricing/category-multipliers/${multiplierId}`, multiplierData);
      return response.data;
    } catch (error) {
      console.error('Erro ao atualizar multiplicadores:', error);
      throw error;
    }
  }
};

export default dynamicPricingService;
